import styles from './confirmModal.module.scss';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function ConfirmModal(props) {
  const { t } = useTranslation();
  return (
    <Modal
      data-testid="ConfirmModal"
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={props.open}
      onClose={() => props.onAction(false)}
      closeAfterTransition
      BackdropProps={{
        timeout: 500,
      }}>
      <Fade in={props.open}>
        <div className={styles.content}>
          <div className={styles.main}>
            <div className={styles.title}>{props.title}</div>
            <IconButton
              data-testid="ConfirmModalCloseIconButton"
              className={styles.close_button}
              onClick={() => props.onAction(false)}>
              <CloseIcon fontSize={'large'} />
            </IconButton>
          </div>
          <div className={styles.description}>{props.description}</div>
          <div className={styles.buttons}>
            <Button
              data-testid="ConfirmModalCloseButton"
              className={styles.buttons_no}
              size="small"
              variant="contained"
              onClick={() => props.onAction(false)}>
              {t('step5.spaceDrawer.no')}
            </Button>
            <Button
              data-testid="ConfirmModalOpenButton"
              className={styles.buttons_yes}
              size="small"
              variant="contained"
              onClick={() => props.onAction(true)}>
              {t('step5.spaceDrawer.yes')}
            </Button>
          </div>
        </div>
      </Fade>
    </Modal>
  );
}
